module.exports = __webpack_public_path__ + "img/Icon ionic-md-arrow-dropdown.7eb06515.svg";